module.exports = __webpack_public_path__ + "img/8.53b769ae.svg";